export default "__VITE_ASSET__D6g6GNFU__"